export const StatusType = {
    closed:"CLOSED",
    archive:"ARCHIVE",
    active:"ACTIVE",
    draft:"DRAFT",
    qualification:"QUALIFICATION",
    toAssign:"TOASSIGN",
    delayed:"DELAYED",
    assigned:"ASSIGNED"
}